import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { resourceServerUrl } from '../constants/auth-keys';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class LastRecordAccessService {

    private updateLRAURI: string = `${resourceServerUrl}/api/last_record_accessed/update_lra`;
    private insertRecordLRAURI: string = `${resourceServerUrl}/api/last_record_accessed/save_patient_record_access_lra`;
    private insertSOAPLRAURI: string = `${resourceServerUrl}/api/last_record_accessed/save_patient_soap_access_lra`;

    constructor(private http: HttpClient) { }

    updateLRA(): Observable<HttpResponse<any>> {
        return this.http.get(this.updateLRAURI, { observe: 'response' });
    }

    insertRecordLRA(patientKey: string): Observable<HttpResponse<any>> {
        //console.log('insertRecordLRA ' + patientKey);
        //console.log(this.insertRecordLRAURI);
        return this.http.get(this.insertRecordLRAURI + `?patientKey=${patientKey}`, { observe: 'response' });
    }

    insertSOAPLRA(patientKey: string): Observable<HttpResponse<any>> {
        return this.http.get(this.insertSOAPLRAURI + `?patientKey=${patientKey}`, { observe: 'response' });
    }
}
